import { Badge } from "react-bootstrap";
import ESGRow from "./ESGRow";

function ESGList(props) {
  const { data, total } = props;

  const setValueAtIndex = (newValue, index) => {
    const newState = data.map((item, i) => {
      if (i === index) {
        return { ...item, value: newValue };
      }
      return item;
    });
    props.onChange(newState);
  };

  return data === null ? (
    <Badge />
  ) : (
    <ol className="list-group">
      {data.map((item, index) => (
        <li key={`${index}-${item.name}`} className="list-group-item">
          <ESGRow
            item={item}
            max={total}
            onChange={setValueAtIndex}
            config={{
              showValues: true,
              showSlider: true,
              index: index,
              total: total,
            }}
          />
        </li>
      ))}
    </ol>
  );
}

export default ESGList;
